import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const incrementValueCommentThreadVersionNumber: YJSChangeHandler<
  DatabaseChangeType.INCREMENT_VALUE_COMMENT_THREAD_VERSION_NUMBER
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.incrementCommentThreadVersionNumber(
      getValueId(change.entryId, change.fieldId),
      change.threadId
    );
  });
};
